import { useEffect, useState } from 'react';

const STORAGE_KEY = 'offline_invoice';

const useOfflineInvoice = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	const saveInvoice = (data) => {
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
		} catch (e) {}
	};

	const getInvoice = () => {
		try {
			const data = localStorage.getItem(STORAGE_KEY);
			return data ? JSON.parse(data) : null;
		} catch (e) {
			return null;
		}
	};

	const deleteInvoice = () => {
		localStorage.removeItem(STORAGE_KEY);
	};

	return {
		saveInvoice,
		getInvoice,
		deleteInvoice,
		isOnline,
	};
};

export default useOfflineInvoice;
